<div
  [ngClass]="
    analyticsService?.currentTheme === 'material-dark' ? 'dark-theme' : ''
  "
>
  <ngx-spinner
    template="<img src='/assets/icons/Respond-spinner.gif' height='170' width='170' class='text-center' loading='lazy'/>"
    [showSpinner]="loading"
    size="small"
    [disableAnimation]="false"
    color="white"
    bdColor="rgba(0,0,0,0.5)"
    [fullScreen]="false"
    [zIndex]="1003"
  >
  </ngx-spinner>
  <form [formGroup]="resetPasswordForm">
    <div class="row">
      <div class="col-md-12" *ngIf="!isPassword">
        <div class="form-group">
          <label class="quicksand-bold-label"
            >Enter Email Address <span class="required-field">*</span></label
          >
          <input
            type="text"
            fullWidth
            nbInput
            formControlName="email"
            placeholder="Enter Your Email Address"
          />
          <label
            class="quicksand-bold-label error-label"
            *ngIf="
              resetPasswordForm.controls.email.invalid &&
              (resetPasswordForm.controls.email.dirty ||
                resetPasswordForm.controls.email.touched)
            "
            >Enter Valid Email Address</label
          >
        </div>
      </div>

      <div class="col-md-12" *ngIf="!isPassword">
        <button
          nbButton
          class="send-code w-100 text-capitalize quicksand-bold-label"
          [title]="
            !resetPasswordForm.value.email
              ? 'Please enter your email properly'
              : 'Send Code'
          "
          [disabled]="!resetPasswordForm.value.email"
          (click)="sendCodeToEmail()"
        >
          Send Code
        </button>
      </div>

      <div class="w-100" *ngIf="isPassword && !isShowPassword">
        <div class="col-md-12">
          <div class="form-group">
            <label class="quicksand-bold-label"
              >Enter Code <span class="required-field">*</span></label
            >
            <input
              type="text"
              fullWidth
              nbInput
              formControlName="code"
              placeholder="Enter Code that you received in your email"
            />
          </div>
        </div>

        <div class="col-md-12">
          <button
            nbButton
            class="send-code w-100 text-capitalize quicksand-bold-label"
            [disabled]="!resetPasswordForm.value.code"
            (click)="verifyCode()"
          >
            Verify Code
          </button>
        </div>
      </div>

      <div *ngIf="isPassword && isCodeVerified" class="w-100">
        <div class="col-md-12">
          <div class="form-group">
            <label class="quicksand-bold-label"
              >Enter Your New Password
              <span class="required-field">*</span></label
            >
            <input
              type="text"
              fullWidth
              nbInput
              formControlName="password"
              placeholder="Enter Your New Password"
              [type]="isShowPasswordText ? 'text' : 'password'"
            />
            <span
              class="p-viewer cursor-pointer"
              (click)="isShowPasswordText = !isShowPasswordText"
            >
              <nb-icon
                icon="eye-off-outline"
                *ngIf="!isShowPasswordText"
              ></nb-icon>
              <nb-icon icon="eye-outline" *ngIf="isShowPasswordText"></nb-icon>
            </span>
            <label
              class="quicksand-bold-label error-label"
              *ngIf="
                resetPasswordForm.controls.password.invalid &&
                (resetPasswordForm.controls.password.dirty ||
                  resetPasswordForm.controls.password.touched)
              "
              >Enter Valid Password</label
            >
          </div>
        </div>

        <div class="col-md-12">
          <div class="form-group">
            <label class="quicksand-bold-label"
              >Confirm Password <span class="required-field">*</span></label
            >
            <input
              type="text"
              fullWidth
              nbInput
              formControlName="confirmPassword"
              placeholder="Confirm Password"
              [type]="isShowConfirmPasswordText ? 'text' : 'password'"
            />
            <span
              class="p-viewer cursor-pointer"
              (click)="isShowConfirmPasswordText = !isShowConfirmPasswordText"
            >
              <nb-icon
                icon="eye-off-outline"
                *ngIf="!isShowConfirmPasswordText"
              ></nb-icon>
              <nb-icon
                icon="eye-outline"
                *ngIf="isShowConfirmPasswordText"
              ></nb-icon>
            </span>
            <label
              class="quicksand-bold-label error-label"
              *ngIf="
                resetPasswordForm.value.password &&
                resetPasswordForm.value.confirmPassword &&
                resetPasswordForm.value.password !==
                  resetPasswordForm.value.confirmPassword
              "
            >
              Password and Confirm Password must be same
            </label>
          </div>
        </div>

        <div class="col-md-12">
          <button
            nbButton
            class="send-code w-100 text-capitalize quicksand-bold-label"
            [disabled]="
              resetPasswordForm.value.password &&
              resetPasswordForm.value.confirmPassword &&
              resetPasswordForm.value.password !==
                resetPasswordForm.value.confirmPassword
            "
            (click)="resetPassword()"
          >
            Reset Password
          </button>
        </div>
      </div>
    </div>
  </form>
</div>
